import BaseCookiesBar, {
  CookiesBarProps,
} from "@acin.reactjs/acin-ui/cookiesBar";
import { useCallback, useMemo } from "react";
import { Trans } from "react-i18next";
import { acinPrivacyPolityUrl } from "../../constants/AppConstants";
import useAppContext from "../../hooks/useAppContext";
import LinkComponent from "../../pages/public/components/link/LinkComponent";

const CookiesBar = (props: CookiesBarProps) => {
  const {
    state: { language },
  } = useAppContext();

  const defaultMessages = useMemo(
    () => ({
      description: (
        <Trans
          i18nKey="cookiesBar.description"
          components={{
            1: (
              <LinkComponent href={acinPrivacyPolityUrl} target="_blank">
                Política de Cookies
              </LinkComponent>
            ),
          }}
        />
      ),
    }),
    [],
  );

  const handleAcceptCookies = useCallback(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    }
  }, []);

  const handleRejectCookies = useCallback(() => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
      });
    }
  }, []);

  return (
    <BaseCookiesBar
      onAcceptCallback={handleAcceptCookies}
      onRejectCallback={handleRejectCookies}
      defaultMessages={defaultMessages}
      key={language}
      {...props}
    />
  );
};

export default CookiesBar;
